import React from 'react';

// style
import './style.scss';

export default function Filter({ filter, onClick, filterId }) {
  return (
    <div
      className={filterId === filter.filter ? 'filter active' : 'filter'}
      onClick={onClick}
    >
      <p>{filter.filter}</p>
    </div>
  );
}
